import type { IFeedCard } from "src/components/feed-card/types/feed-card";
import { INITIAL_FEED_ITEMS_TO_SHOW, INITIAL_FEED_ITEMS_TO_SHOW_WITH_PINNED } from "src/components/pages/detail/feed/feed.constants";

export const getShouldShowMoreButton = (
    hasNextPage: boolean,
    isShowMoreClicked: boolean,
    unpinnedFeed: IFeedCard[] | null,
    hasPinnedCard: boolean
) => {
    const initialItemsToShow = hasPinnedCard ? INITIAL_FEED_ITEMS_TO_SHOW_WITH_PINNED : INITIAL_FEED_ITEMS_TO_SHOW;
    const hasMoreInCurrentPage = Boolean(unpinnedFeed && unpinnedFeed.length > initialItemsToShow);

    return hasNextPage || (!isShowMoreClicked && hasMoreInCurrentPage);
};
